<template>
    <div class="isEveBOx" v-if="comVipShow">
        <div class="isEveContent">
            <div class="closeTitle">
                <div class="bigTitle">恭喜您，成功升级为 <span>永久会员</span></div>
            </div>

                  <div class="payDetailSucc">
                    会员有效至： <span class="endSty">{{endDate}}（100年）</span> 
                </div>
        <div class="closeOrOpen" @click="close()">
            <img src="./img/closeLoginIc.png" class="closeIconBtn" alt="">
        </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
export default{
  data(){
    return{
      endDate:'',

    }
  },
  mounted(){
    this.gitTime()
  },
  methods:{
    gitTime() {
      const now = new Date();
      const year = now.getFullYear(); // 获取当前年份
      const month = now.getMonth() + 1; // 获取当前月份，注意getMonth()返回的是0-11，所以需要加1
      const day = now.getDate(); // 获取当前日期
    //   tipMsgDate.value = year + '-' + month + '-' + day;
      this.endDate = (year + 100) + '-' + month + '-' + day;
    },
    close(){
        this.$store.commit('setcomVipShow',false)
    }
  },
  computed:{
    comVipShow() {
      return this.$store.state.comVipShow
    },
  }

}
</script>

<style lang="scss" scoped>
.isEveBOx {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, .5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;

    .isEveContent {
        padding: 10px 20px;
        // width: 900px;
        width: calc(100vw - 20px);
        height: 380px;

        position: relative;
        background-image: url("./img/vip_plan/011.png");
        background-size: 100% 100%;
        border-radius: 13px;
        display: flex;
        flex-direction: column;

        .closeTitle {
            padding-bottom: 10px;
            // margin-top: 35px;

            .bigTitle {
                font-size: 22px;
                font-weight: 700;
                color: #4a3304;
                // margin-bottom: 15px;
                margin-top: 20px;
                span {
                    color: #f64834;
                }
            }
        }
            .payDetailSucc{
                width: 100%;
                height: 300px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #000000;
      .endSty{
        color: #cb3131;
      }
    }
    }
      .closeOrOpen {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #fff;
    position: absolute;
    bottom: -60px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      height: 20px;
      cursor: pointer;
    }
  }
}
</style>